import { default as React, useState, useEffect } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import TextField from '@mui/material/TextField';

export const PortFieldExtension = ({
  onChange,
  rawErrors,
  required,
  formData,
  schema,
}: FieldExtensionComponentProps<number>) => {
  const getInitialValue = () => {
    if (formData !== undefined) return String(formData);
    if (schema.default) return String(schema.default);
    return '';
  };

  const [inputValue, setInputValue] = useState(getInitialValue());

  useEffect(() => {
    if (formData !== undefined) {
      setInputValue(String(formData));
    }
  }, [formData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value); // always update display so keystrokes are visible

    if (value === '') {
      onChange(undefined);
      return;
    }
    if (/^\d+$/.test(value)) {
      const numValue = Number(value);
      if (numValue >= 1 && numValue <= 65535) {
        onChange(numValue);
      } else {
        onChange(undefined); // invalid range — validator will surface error
      }
    } else {
      onChange(undefined); // non-numeric — validator will surface error
    }
  };

  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  };

  return (
    <TextField
      label={schema.title || 'Container Port'}
      type="text"
      inputMode="numeric"
      value={inputValue}
      onChange={handleChange}
      onWheel={handleWheel}
      placeholder={schema.default ? String(schema.default) : '3001'}
      helperText={
        rawErrors?.length > 0 ? rawErrors.join(', ') : schema.description
      }
      error={rawErrors?.length > 0}
      required={required}
      fullWidth
      inputProps={{
        pattern: '[0-9]*',
        name: 'containerPort',
      }}
      sx={{
        '& input[type=text]::-webkit-inner-spin-button, & input[type=text]::-webkit-outer-spin-button':
          {
            WebkitAppearance: 'none',
            margin: 0,
          },
        '& input[type=text]': {
          MozAppearance: 'textfield',
        },
      }}
    />
  );
};
